import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type UserRolesState = CommonTableState;

const initialState: UserRolesState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "user.person.lastName", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            roleCode: false,
            created: false,
            creator: false,
        },
        columnOrder: ["user.id", "user.person.id", "appRoleCode", "creator", "validFrom", "validTo", "created", "mrt-row-actions"],
        density: "compact",
    },
};

export const userRolesSlice = createSlice({
    name: "userRoles",
    initialState: initialState,
    reducers: {
        updateUserRoleTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updateUserRoleTableState} = userRolesSlice.actions;

export default userRolesSlice.reducer;
